import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
import { Typography } from '@mui/material';
import React from 'react';

const ValueDisplay = ({ value, isCurrency }) => {
  if (value == null || value == 0 || isNaN(value)) {
    return null;
  }

  let formattedValue;
  if (isCurrency) {
    formattedValue = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(value);
  } else {
    formattedValue = Math.round(value);
  }

  const color = value > 0 ? 'green' : 'red';
  const Icon = value > 0 ? ArrowUpward : ArrowDownward;

  return (
    <Typography style={{ color: color }}>
      {value !== 0 && <Icon />}
      {formattedValue}
    </Typography>
  );
};

export default ValueDisplay;
